import { createAuthClient } from 'better-auth/client';

import { API_ORIGIN } from './client.ts';

export const authClient = createAuthClient({
  baseURL: API_ORIGIN,
  basePath: '/auth',
});
